import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Video, Building2 } from "lucide-react";

const PALETTE = [
  "bg-[hsl(var(--primary))]",
  "bg-orange-500",
  "bg-purple-600",
  "bg-yellow-600",
  "bg-teal-600",
  "bg-pink-500",
  "bg-blue-600",
  "bg-rose-600",
  "bg-emerald-600",
  "bg-indigo-600",
  "bg-amber-600",
  "bg-fuchsia-600",
];

const TEXT_PALETTE = [
  "text-[hsl(var(--primary))]",
  "text-orange-500",
  "text-purple-600",
  "text-yellow-600",
  "text-teal-600",
  "text-pink-500",
  "text-blue-600",
  "text-rose-600",
  "text-emerald-600",
  "text-indigo-600",
  "text-amber-600",
  "text-fuchsia-600",
];

function hashIndex(str: string, mod: number) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h % mod;
}

export function colorForAccompaniment(title: string) {
  const i = hashIndex(title.toLowerCase().trim(), PALETTE.length);
  return { bg: PALETTE[i], text: TEXT_PALETTE[i] };
}

interface Item {
  id: string;
  title: string;
}

export const AppointmentLegend = () => {
  const [items, setItems] = useState<Item[]>([]);

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from("accompaniments")
        .select("id,title")
        .eq("user_id", user.id)
        .eq("is_active", true)
        .order("display_order");
      setItems((data as Item[]) || []);
    })();
  }, []);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 mb-4 p-3 sm:p-4 bg-card rounded-lg border border-border overflow-x-auto">
      <span className="text-muted-foreground font-medium text-sm sm:text-base shrink-0">Légende :</span>
      <div className="flex flex-wrap items-center gap-3 sm:gap-4">
        {items.map((it) => {
          const { bg, text } = colorForAccompaniment(it.title);
          return (
            <div key={it.id} className="flex items-center gap-2">
              <div className={`w-3 h-3 sm:w-4 sm:h-4 rounded shrink-0 ${bg}`} />
              <span className={`${text} font-medium text-xs sm:text-sm`}>{it.title}</span>
            </div>
          );
        })}
        <div className="flex items-center gap-3 ml-auto border-l pl-3">
          <div className="flex items-center gap-1">
            <Video className="w-3 h-3 text-blue-600" />
            <span className="text-xs sm:text-sm text-muted-foreground">Visio</span>
          </div>
          <div className="flex items-center gap-1">
            <Building2 className="w-3 h-3 text-green-700" />
            <span className="text-xs sm:text-sm text-muted-foreground">Cabinet</span>
          </div>
        </div>
      </div>
    </div>
  );
};
